import { BenAdminLead } from "RegisterBenAdmin/types";

export const baseURL = "/register-benefits-administration";
export const startURL = `${baseURL}/start`;
export const paymentURL = `${baseURL}/payment`;
export const additionalInformationURL = `${baseURL}/additional-information`;
export const doneURL = `${baseURL}/done`;

export const nextPageURL = (benAdminLead: BenAdminLead) => {
  const { status } = benAdminLead;
  let nextSectionUrl = startURL;
  if (status === "payment") {
    nextSectionUrl = paymentURL;
  } else if (status === "additional_information") {
    nextSectionUrl = additionalInformationURL;
  } else if (status === "done") {
    nextSectionUrl = doneURL;
  }
  return nextSectionUrl;
};
